import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  productListByFilter,
  removeProductMutation,
} from '../../shared/queries/Product';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';

const Product = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadAllProducts = () => {
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id: 0,
      value: 0,
    };
    const query = productListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        res.productListByFilter = res.productListByFilter.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(res.productListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    toggleModal();

    showLoading();
    const removeMutation = removeProductMutation(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        loadAllProducts();
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/produto/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/produto/mnt/${rowData.id}`);
  };

  useEffect(() => {
    loadAllProducts();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onRefreshClick={loadAllProducts}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('panels.produto')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Product.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Product)
);
